import { encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";

class NewsStore {
  loading = false;
  total = 0;
  newsList = [];

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      loading: observable,
      total: observable,
      newsList: observable,

      loadData: action,
      deleteRecord: action,
      getNewsData: action,
      addData: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ companyId, offset, limit, page }) {
    this.loading = true;
    var postData = {
      companyId: 1,
      offset: offset,
      limit: limit,
      page: page,
    };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .get(config.NodeUrl + "/taxi_content/getNews", {
        params: postData,
      });

    this.newsList = response?.data?.contentData;
    this.total = parseInt(response?.data?.TotalCount);

    this.loading = false;
  }

  async addData(postData) {
    var discountDetails = { postData };

    var response = await postApi
      .getClient()
      .post(config.NodeUrl + "/taxi_content/updateContent", discountDetails);

    return response.data;
  }

  async getNewsData(contentId) {
    var postData = { contentId: contentId, limit: 1, offset: 0 };
    var response = await postApi
      .getClient()
      .get(config.NodeUrl + "/taxi_content/getNews", {
        params: postData,
      });
    return response?.data?.contentData[0];
  }

  async deleteRecord({ id }) {
    const postData = {
      id: id,
    };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .delete(config.NodeUrl + "/taxi_content/deleteContent", {
        params: postData,
      });

    return response;
  }
}

export default NewsStore;
